import {Link} from 'react-router-dom';
import {ArrowLeftOutlined} from '@ant-design/icons';

import {ExpenseReportActions} from '../../actions';
import {Toast, notify} from '../../components/ui/Toast/Toast';
import Table from '../../components/ui/Table';
import {expensesTableConfig} from './config/expensesTableConfig';

const ExpensesToCheckPage = ({
    userData,
    data,
    actionButtonLoading,
    setActionButtonDisabled,
    setActionButtonLoading,
    refreshData,
    filterExpenseReportList,
    tableType,
    paginationMetadata,
    onPageNumberChange,
    tableLoading
}) => {

    // const handleDeleteExpenseReport = async (item) => {
    //     setActionButtonDisabled(true);
    //     setActionButtonLoading(`${item.id}del`);

    //     const result = await ExpenseReportActions.deleteExpenseReportById(userData, item.id);

    //     if (result.success) {
    //         await refreshData(true);
    //         notify('La note de frais a bien été supprimée');
    //     }
    //     else {
    //         notify(`La note de frais n'a pas pu être supprimée\n${result.error.message}`);
    //     }

    //     setActionButtonLoading(null);
    //     setActionButtonDisabled(false);
    // };

    const handleCheckExpenseReport = async (item) => {
        setActionButtonDisabled(true);
        setActionButtonLoading(`${item.id}val`);

        const result = await ExpenseReportActions.updateExpenseReportById(userData, item.id, {status: 2});

        if (result.success) {
            await refreshData(true);
            notify('Votre note de frais est en attente de paiement');
        }
        else {
            notify('Votre note de frais n\'a pas pu être mise à jour');
        }

        setActionButtonLoading(null);
        setActionButtonDisabled(false);
    };

    const tableConfig = expensesTableConfig(
        // handleDeleteExpenseReport,
        actionButtonLoading,
        null,
        handleCheckExpenseReport,
        filterExpenseReportList,
        tableType,
        userData
    );

    return (
        <>
            <Toast/>
            <div className='flex items-center justify-between my-10'>
                <Link to='/dashboard/office-manager'>
                    <ArrowLeftOutlined style={{fontSize: '25px'}}/>
                </Link>
                <h1
                    className='text-3xl font-bold'
                    style={{fontFamily: 'DIN Condensed'}}
                >
                    {`Notes de frais à vérifier (${paginationMetadata.totalItems})`}
                </h1>
                <div/>
            </div>
            <Table
                data={data}
                tableConfig={tableConfig}
                paginationMetadata={paginationMetadata}
                onPageNumberChange={onPageNumberChange}
                loading={tableLoading}
            />
        </>
    )
}

export default ExpensesToCheckPage;
